import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';

import { NotFoundComponent } from '@system/not-found/not-found.component';
import { CipoKeyboardListDirective } from './keyboard-list.directive';

@NgModule({
  imports: [NotFoundComponent, CipoKeyboardListDirective],
  exports: [MatPaginatorModule, ScrollingModule, NotFoundComponent, CommonModule, CipoKeyboardListDirective],
})
export class VirtualListModule {}
